import Toewijzing from '../types/Toewijzing';
import { Get } from './helpers/builder';

export const toewijzingList = Get`/lists/providers/${'provider'}/list/allocations`.json<{ response: Toewijzing[] }>();

export const toewijzingListActive = Get`/lists/providers/${'provider'}/active`.status(f => ({
	200: f.json<Toewijzing[]>(),
	422: f.json<Toewijzing[]>(),
}));
